//Turf
import { helpers } from "@turf/turf";
import * as localDb from '../localDb'
import refDataById from "../localRefData/refDataById";
import { siteNavLocation } from "./siteNavLocation";

export default async function buildSiteFeatureCollection(sites) {
    let features = await Promise.all(sites.map(site => {
        return new Promise(async (resolve, reject) => {
            // Same precedence as navigation: a site relocated but not yet confirmed
            // must be drawn where the technician was sent, not at the planning anchor.
            // This used to be masked because relocation overwrote plannedLocation.
            let coords = siteNavLocation(site);
            let turfPosition = [coords[1], coords[0]];
            let siteFeature = helpers.point(turfPosition, { id: site.name });
            let activities = await localDb.getMany('activities').then(result => result.where({monitoringSiteId: site.id}).toArray());
            let properties = activities.reduce((acc, curr) =>{
                acc[curr.key] = refDataById('taskStatus', curr.taskStatusId);;
                return acc
            }, { 
                hasActivities: activities && activities.length,
                isValidationSite: site.isValidationSite
            });
            siteFeature.properties = {...siteFeature.properties, ...properties}
            resolve(siteFeature);
        });
    }));
    let fc = helpers.featureCollection(features);
    return fc;
}